import { Flex } from "@chakra-ui/layout";
import {
  Switch, Text, Alert,
  AlertIcon,
  AlertDescription,
} from "@chakra-ui/react";
import colors from "core/resources/theme/colors";
import React, { useState, useEffect } from "react";
import { BiChevronDown, BiChevronUp } from "react-icons/bi";
import { Collapse } from "antd";


const { Panel } = Collapse;

interface InputToggleContentProps {
  label: string;
  active: boolean;
  onToggle: (checked: boolean) => any;
  children?: React.ReactNode;
  size?: "sm" | "lg";
  buttonIcon?: React.ReactNode;
  disabled?: boolean;
  disabledMessage?: string;
}
function InputToggleContent({
  label,
  active,
  onToggle,
  children,
  size = "lg",
  buttonIcon,
  disabled = false,
  disabledMessage,
}: InputToggleContentProps) {
  const [openCollapse, setOpenCollapse] = useState(active);

  useEffect(() => {
    if (disabled) {
      setOpenCollapse(false);
      return;
    }

    if (active) {
      setOpenCollapse(true);
    } else {
      setOpenCollapse(false);
    }
  }, [active, disabled]);

  return (
    <Flex
      w="100%"
      borderWidth={1}
      rounded={"10px"}
      borderColor={active ? colors.primary : colors.blueishGray100}
      pt={size === "lg" ? 6 : 2}
      px={4}
      flexDir="column"
    >
      <Flex alignItems="center" mb={(size === "lg" || disabled) ? 0 : -4} zIndex={2} w="100%">
        <Switch onChange={() => onToggle(!active)} isChecked={active} disabled={disabled} />
        <Flex
          onClick={() => !disabled && setOpenCollapse((prev) => !prev)}
          cursor={disabled ? "not-allowed" : "pointer"}
          w="100%"
          align="center"
          gap={4}
        >
          <Text ml={4} mt={"1px"}>
            {label}
          </Text>
          {buttonIcon}

          <Flex ml="auto">
            {openCollapse ? (
              <BiChevronUp size={23} />
            ) : (
              <BiChevronDown size={23} />
            )}
          </Flex>
        </Flex>
      </Flex>
      {disabled && disabledMessage ? (
        <Alert status="warning" mb="16px" mt={2}>
          <AlertIcon />
          <AlertDescription>
            {disabledMessage}
          </AlertDescription>
        </Alert>
      ) : null}
      {!disabled && children ? (
        <Collapse
          activeKey={openCollapse ? "1" : undefined}
          ghost
          className="input-toggle-collapse"
        >
          <Panel key={"1"} header="" showArrow={false}>
            {children}
          </Panel>
        </Collapse>
      ) : null}
    </Flex>
  );
}

export default InputToggleContent;
